import React from 'react';

import { Typography } from '@vtblife/uikit';
import Icon, { IconMediumSize } from '@vtblife/uikit-icons';
import Grid from '@vtblife/uikit-grid';

import type { QuizLastStep } from '@search/graphql-typings';
import classname from '@search/classname/src';

import './styles.css';

const cn = classname.bind(null, 'QuizBuilderFinalStepBonusList');

const QuizBuilderFinalStepBonusList = ({
    bonusList,
    withPromoCode,
    isMobile
}: {
    bonusList: QuizLastStep['bonusList'];
    withPromoCode?: boolean;
    isMobile?: boolean;
}) => bonusList.length > 0 ? (
    <div className={cn()}>
        <Grid cols={isMobile ? 1 : 2}>
            {bonusList.map(({ iconName, iconColor, point, promoCode }, idx, array) => (
                <Grid.Cell key={idx}>
                    <div className={cn('item')}>
                        <div className={cn('icon')}>
                            <Icon
                                size='m'
                                name={iconName as IconMediumSize}
                                color={iconColor ?? '#FF784B'}
                            />
                        </div>
                        <div>
                            <Typography
                                variant='primary'
                                bold
                            >
                                {point} {
                                    withPromoCode ? (
                                        <Typography
                                            tag='span'
                                            variant='primary'
                                            color='secondary'
                                        >
                                            {promoCode}
                                        </Typography>
                                    ) : null
                                }{idx < array.length - 1 ? ';' : '.'}
                            </Typography>
                        </div>
                    </div>
                </Grid.Cell>
            ))}
        </Grid>
    </div>
) : null;

export default QuizBuilderFinalStepBonusList;
